module.exports = __webpack_public_path__ + "img/30.3d09ee8b.png";